import Client from './client';

export default class TariffEligibilities extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/tariff/eligibilities`, options);
  }

  getByType(organization, type, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/tariff/eligibilities/${type}`, options);
  }

  putByType(organization, type, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/tariff/eligibilities/${type}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByType(organization, type, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/harmonization/tariff/eligibilities/${type}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
